import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-drop-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-semibold text-lg text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
                白浆百科
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              白浆百科致力于为行业从业者和研究者提供全面、专业的白浆知识体系，涵盖建筑、造纸、食品及工业等领域的白浆原料、工艺、性能与选购指南。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-950 mb-4">
              <a href="#quick-links" className="cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">产品分类</Link></li>
              <li><Link to="/category?tab=construction" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">建筑白浆</Link></li>
              <li><Link to="/category?tab=paper" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">造纸白浆</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-950 mb-4">
              <a href="#categories-links" className="cursor-pointer">产品类别</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/category?tab=food" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">食品级白浆</Link></li>
              <li><Link to="/category?tab=industrial" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">工业白浆</Link></li>
              <li><Link to="/category?tab=construction" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">建筑白浆</Link></li>
              <li><Link to="/category?tab=paper" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">造纸白浆</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-foreground-950 mb-4">
              <a href="#contact-info" className="cursor-pointer">联系方式</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                <span>contact@baijiang-baike.com</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-phone-line mt-0.5 text-foreground-500"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-600">
                <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                <span>中国上海市浦东新区张江高科技园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 白浆百科. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#terms" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">使用条款</a>
            <a href="#sitemap" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}